import React from "react";
import { withTranslation } from "react-i18next";
import { Box, Typography, Grid, Link } from "@mui/material";
import { ElipseTop, ElipseBottom } from "../utils/theme";
import { PartnersImageHover } from "../utils/theme";
import SwissBorg from "../assets/Partners/SwissBorg.png";
import CryptoSociety from "../assets/Partners/CryptoSociety.png";
import Palmera from "../assets/Partners/Palmera.svg";
import BlockchainClubUZH from "../assets/Partners/BlockchainClubUZH.png";
import HEC from "../assets/Partners/HEC.png";
import LiiPrint from "../assets/Partners/LiiPrint.svg";
import Flux from "../assets/Partners/Flux.svg";

const PartnersComponent = ({ t }) => {
  const partners = [
    { name: "SwissBorg", image: SwissBorg, url: "https://swissborg.com/" },
    { name: "Flux", image: Flux, url: "https://runonflux.io" },
    {
      name: "BlockchainClubUZH",
      image: BlockchainClubUZH,
      url: "https://www.blockchainclubuzh.ch/",
    },
    {
      name: "CryptoSociety",
      image: CryptoSociety,
      url: "http://cryptosocietystgallen.club/",
    },
    { name: "Palmera", image: Palmera, url: "https://palmeradao.xyz/" },

    { name: "HEC", image: HEC, url: "https://www.hecmba-blockchain.com/" },
    { name: "LiiPrint", image: LiiPrint, url: "https://shop.liiprint.ch/" },
  ];

  return (
    <Box sx={{ backgroundColor: "secondary.main" }}>
      <ElipseTop />
      <Grid container flexDirection="column" alignItems="center" pb={10}>
        <Typography variant="h2" mt={15} mb={1}>
          {t("partnersComponent.title")}
        </Typography>
        <Typography variant="h4" textAlign="center" mb={5} px={2}>
          {t("partnersComponent.subTitle")}
        </Typography>
        <Grid
          container
          item
          xs={10}
          justifyContent="center"
          rowSpacing={5}
          columnSpacing={2}
        >
          {partners.map((partner) => (
            <Grid item xs={10} sm={6} md={4} key={partner.name}>
              <Link
                target="_blank"
                href={partner.url}
                aria-label={partner.name}
              >
                <PartnersImageHover>
                  <img
                    src={partner.image}
                    alt={partner.name}
                    width="100%"
                    height="auto"
                  />
                </PartnersImageHover>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <ElipseBottom />
    </Box>
  );
};

export default withTranslation()(PartnersComponent);
